import React from "react";
import { navigateTo } from "gatsby-link";

export default ({ label, link, classes = null }) => (
  <button
    title={`${link.title}`}
    onClick={() => navigateTo(`/${link.slug}`)}
    className={`button is-primary is-large is-callout-button${
      classes ? " " + classes : ""
      }`}
  >
    {label}
  </button>
);



// WEBPACK FOOTER //
// ./src/components/CalloutButton.js